import { render, staticRenderFns } from "./allOverTime.vue?vue&type=template&id=487d4e5a&scoped=true"
import script from "./allOverTime.vue?vue&type=script&lang=js"
export * from "./allOverTime.vue?vue&type=script&lang=js"
import style0 from "./allOverTime.vue?vue&type=style&index=0&id=487d4e5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487d4e5a",
  null
  
)

export default component.exports